import React from "react";
import useSelect from "hooks/useSelect";
import { useQueryClient } from "react-query";
import { t } from "i18next";
import TableToolbar from "components/Table/TableToolbar/TableToolbar";
import clsx from "clsx";
import { RssService } from "service/rss.service";
import promiseToast from "components/Toasts/PromiseToast";

export default function RssTableToolbar(props: any) {
	const { selectedRows, clearSelection } = props;
	const { confirmDelete } = (useSelect as any)();
	const QCL = useQueryClient();

	function handleDelete() {
		// if (!selectedRows?.length) return false;
		let title = t("Rss.ASKDELETE", {
			count: selectedRows?.length,
			name: selectedRows[0].name,
		});
		confirmDelete(
			() => {
				delSelecteds();
			},
			null,
			title as any,
			null
		);
	}

	function delSelecteds() {
		let proms = selectedRows.map((rss: any, x: number) => {
			let prom: any = false;
			prom = new Promise((resolve, reject) => {
				setTimeout(() => {
					RssService.deteleRssFeed(rss.id).then((resp: any) => {
						resolve(resp);
					}, reject);
				}, 500 * x);
			});
			return prom;
		});

		let prom = Promise.allSettled(proms).then(() => {
			clearSelection();
			props.resetFc();
		});

		(promiseToast as any)(prom, {
			pending: t("Rss.DELETING", { count: selectedRows?.length }),
		});
		return prom;
	}

	return (
		<div className={clsx(selectedRows.length > 0 && "rssToolbar")}>
			<TableToolbar
				{...props}
				handleDelete={handleDelete}
				buttons={[
					{
						title: "delete",
						onClick: handleDelete,
					},
				]}
			/>
		</div>
	);
}
